<template>
  <section id="card-text-alignment">
    <b-row>
      <b-col
        md="10"
        lg="10"
      >
        <!-- warning -->
        <b-alert
          variant="warning"
          show
        >
          <h4 class="alert-heading">
            Você precisa saber disso!
          </h4>
          <div class="alert-body">
            <span>Fazer envio em massa é passivo de banimento no whatsapp, por favor, utilize a ferramenta com cautela.</span>
          </div>
        </b-alert>
        <b-alert
          variant="primary"
          :show="showAlertFree()"
          dismissible
          @dismissed="showAlertFree = false"
        >
          <h4 class="alert-heading">
            Recurso não disponivel para o plano de teste
          </h4>
          <div class="alert-body">
            <span>As campanhas estão disponiveis apartir do plano super.</span>
          </div>
        </b-alert>
      </b-col>
    </b-row>
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <h3 class="mt-3 mb-2">
        Suas Campanhas
      </h3>
      <b-row>
        <!-- center align -->
        <b-col
          v-for="campaign in campaignsList"
          md="6"
          lg="4"
        >
          <b-card
            :title="campaign.name"
            class="text-center"
          >
            <!---<b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-select2
                variant="outline-primary"
                :to="{ name: 'campaign-list', params: { uuid: item.uuid } }"
              >
                Editar
              </b-button>--->
            <!-- primary -->
            <b-button
              v-if="campaign.active === 0"
              v-b-modal.modal-primary
              variant="relief-primary"
              pill
              @click="status = 1; campaignId = campaign.id"
            >
              Iniciar
            </b-button>

            <b-button
              v-if="campaign.active === 1"
              variant="outline-secondary"
              pill
              @click="updateStatusCampaign(0, campaign.id)"
            >
              Parar
            </b-button>
              &nbsp &nbsp
            <b-button
              v-b-modal.modal-multi-1
              variant="outline-secondary"
              pill
              @click="getMetrics(campaign.id), messageCampaing = decodeURIComponent(campaign.message), imageCampaign = campaign.midia, linkButton = campaign.link_button, textButton = campaign.text_button"
            >
              <feather-icon icon="EyeIcon" />
              Ver
            </b-button>
              &nbsp &nbsp
            <b-button
              variant="danger"
              pill
              @click="deleteCampaign(campaign.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </b-card>
        </b-col>

        <!-- center align -->
        <b-col
          md="6"
          lg="4"
        >
          <b-card
            border-variant="primary"
            bg-variant="transparent"
            class="shadow-none text-center"
          >
            <h4>Crie uma nova campanha</h4>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-modal.modal-select2
              variant="outline-primary"
              :to="{ name: 'campaign-edit', params: { store: this.$route.params.store }}"
            >
              Criar
            </b-button>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>

    <!-- modal -->
    <b-modal
      id="modal-primary"
      ok-only
      ok-title="Habilitar"
      modal-class="modal-primary"
      centered
      title="Configure a instância"
      @ok="updateStatusCampaign(null, null)"
    >
      <b-card-text>
        Através de qual whatsapp você deseja enviar a campanha?

        <b-card
          v-if="Selected"

          text-variant="black"
        >
          <b-card-title>
            Selecione a intância
          </b-card-title>
          <b-card-text>
            <b-row>
              <b-col>
                <b-form-group>
                  <v-select
                    v-model="whatsapp"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="option"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-modal>
    <metrics
      :items="metrics"
      :total-send="totalSend"
      :show="showMetrics"
      :message="messageCampaing"
      :image-campaign="imageCampaign"
      :text-button="textButton"
    />
  </section>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BButton, BModal, VBModal, BForm, BFormGroup, BFormTextarea, BFormCheckbox, BOverlay, BFormRadio, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { getUserData } from '@/auth/utils'
import notification from '../../functions/basics/notifications'
import metrics from './metrics/metrics'

export default {
  components: {
    BRow, BCol, BCard, BCardText, BButton, BModal, VBModal, BForm, BFormGroup, vSelect, BFormTextarea, BFormCheckbox, BOverlay, BFormRadio, BAlert, metrics,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      metrics: {},
      campaignsList: [],
      show: false,
      Selected: true,
      option: [],
      whatsapp: null,
      status: null,
      campaignId: null,
      totalSend: 0,
      showMetrics: false,
      messageCampaing: '',
    }
  },
  async mounted() {
    const list = await notification.getCampaigns(this.$route.params.uuid)
    this.campaignsList = list.compaigns
    this.option = await notification.getInstances(this.$route.params.uuid)
  },
  methods: {
    showAlertFree() {
      if (getUserData().role === 'admin' && getUserData().id >= 714 && getUserData().id <= 740) {
        return true
      }
      return false
    },
    async updateStatusCampaign(status, campaignId) {
      status = (status !== null) ? status : this.status
      campaignId = (campaignId !== null) ? campaignId : this.campaignId
      const instance = (this.whatsapp === null) ? null : this.whatsapp.id

      this.show = true
      await notification.updateStatus(status, campaignId, instance, this.$route.params.uuid)
        .then(resp => { if (resp.status === 200) window.location.reload() })
        .catch(error => console.log(error))
    },
    async deleteCampaign(campaignId) {
      this.$swal({
        title: 'Você tem certeza?',
        text: 'Ao clicar em "confirmar" você irá excluir a campanha.',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          await notification.deleteCampaign(campaignId, this.$route.params.uuid)
            .then(async resp => {
              if (resp.status === 200) {
                const list = await notification.getCampaigns(this.$route.params.uuid)
                this.campaignsList = list.compaigns
                this.$swal({
                  icon: 'success',
                  title: 'Excluido!',
                  text: 'A sua campanha foi deletada.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            })
        }
      })
    },
    totalSendMessage() {
      let count = 0
      this.metrics.forEach(message => {
        if (message.message_id) {
          count += 1
        }
      })
      return count
    },
    async getMetrics(campaignId) {
      this.showMetrics = true
      this.metrics = await notification.getMetrics(this.$route.params.uuid, campaignId)
      this.totalSend = await this.totalSendMessage()
      this.showMetrics = false
    },
  },
}
</script>

<style>
  .card-footer{
    color: #2e8c54;
  }
</style>
